import { useMutation } from '@tanstack/vue-query';
import { llmFeedbackApi } from './llmFeedback.endpoints';

function createFeedbackMutation<TPayload>(key: string[], fn: (payload: TPayload) => Promise<void>) {
  return () =>
    useMutation({
      mutationKey: key,
      mutationFn: fn,
    });
}

export const useSubmitLlmRating = createFeedbackMutation(
  ['llmFeedback', 'rating'],
  llmFeedbackApi.submitRating
);

export const useSubmitLlmComment = createFeedbackMutation(
  ['llmFeedback', 'comment'],
  llmFeedbackApi.submitComment
);
